/* eslint-disable react/jsx-pascal-case */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useParams, useNavigate } from 'react-router-dom';
import Topbar from '../PulseSurvey/Topbar';
import Loader from '../../component/common/Loader';
import Breadcrumb from '../../component/common/Breadcrumb';
import SearchInput from '../../component/common/Input/SearchInput';
import Table1 from '../../component/common/Table1';
import Pagination from '../../component/common/Pagination/Pagination';
import { errorToast, successToast, isSuperAdmin } from '../../utils/helper';
import {
  getCustomOfferingById,
  getCompanyCustomOfferingById,
  getUsersCustomOfferings,
  getCompanyUsersCustomOfferings,
  getAdminEnrolledUsersInOffering,
  getCompanyEnrolledUsersInOffering
} from '../../api/offeringApi';
import { PER_PAGE } from '../../utils/constants';
import AddUsersModal from './AddUsersModal';
import Table from '../../component/common/Table';
import { TableCard } from '../../component/common/designSystem';

const getPages = (isAdmin, slug) => {
  if (isAdmin) {
    return [
      { name: 'Perks', href: '/offerings' },
      { name: 'Manage Perk', href: '#', current: true }
    ];
  } else {
    return [
      { name: 'Perks', href: `/${slug}/offerings` },
      { name: 'Manage Perk', href: '#', current: true }
    ];
  }
};

const columns = [
  {
    title: 'User',
    key: 'name',
    sortable: false,
    type: 'text',
    align: 'left'
  },
  {
    title: 'Email',
    key: 'email',
    sortable: false,
    type: 'text',
    align: 'left'
  },

  {
    title: 'Enrolled On',
    key: 'enrollmentDate',
    sortable: false,
    type: 'date',
    align: 'left'
  }
];

const ManageOffering = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem('userData')) || {};
  const { slug } = userData;
  const isAdmin = isSuperAdmin();
  const [loader, setLoader] = useState(true);
  const [perk, setPerk] = useState(null);

  // Users table states
  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [selectedPerPage, setSelectedPerPage] = useState(PER_PAGE[0]);
  const [searchTerm, setSearchTerm] = useState('');
  const [isAddUsersModalOpen, setIsAddUsersModalOpen] = useState(false);

  useEffect(() => {
    if (id) {
      fetchPerkDetails();
    } else {
      setLoader(false);
    }
  }, [id]);

  // Fetch enrolled users when perk, page, or search term changes
  useEffect(() => {
    if (perk?.id) {
      fetchEnrolledUsers();
    }
  }, [perk?.id, currentPage, selectedPerPage, searchTerm]);

  const fetchPerkDetails = async () => {
    setLoader(true);
    try {
      const apiFunction = isAdmin ? getCustomOfferingById : getCompanyCustomOfferingById;
      const response = await apiFunction(id);
      if (response?.status === 200 || response?.data) {
        setPerk(response.data);
        console.log('Perk Details:', response.data);
      } else {
        errorToast('Failed to load perk details');
      }
    } catch (error) {
      console.error('Error fetching perk:', error);
      errorToast(error?.message || 'Error loading perk');
    } finally {
      setLoader(false);
    }
  };

  const fetchEnrolledUsers = async () => {
    if (!id) return;

    try {
      const params = {
        page: currentPage,
        limit: selectedPerPage.value
      };

      if (searchTerm) {
        params.search = searchTerm;
      }

      const apiFunction = isAdmin
        ? getAdminEnrolledUsersInOffering
        : getCompanyEnrolledUsersInOffering;
      const response = await apiFunction(id, params);
      console.log('Enrolled Users Response:', response);
      if (response?.data) {
        setUsers(response.data || []);
        setTotalCount(response.meta?.totalCount || 0);
      } else {
        setUsers([]);
        setTotalCount(0);
      }
    } catch (error) {
      console.error('Error fetching enrolled users:', error);
      errorToast('Failed to load enrolled users');
      setUsers([]);
      setTotalCount(0);
    }
  };

  const handleManageUsers = () => {
    setIsAddUsersModalOpen(true);
  };

  const handleModalClose = () => {
    setIsAddUsersModalOpen(false);
  };

  const handleModalSuccess = () => {
    setIsAddUsersModalOpen(false);
    // Refresh users table after users are added/removed
    refreshTable();
  };

  const handlePerPage = (perPage) => {
    setSelectedPerPage(perPage);
    setCurrentPage(1);
  };

  const handlePagination = (page) => {
    setCurrentPage(page);
  };

  const refreshTable = () => {
    setCurrentPage(1);
    setSearchTerm('');
    fetchEnrolledUsers();
  };

  return (
    <div className="relative lg:mb-[45px]">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{perk ? perk?.title : 'Manage Perk'} | Shoorah Admin</title>
      </Helmet>

      {loader && <Loader />}

      <Topbar title={perk ? perk?.title : 'Manage Perk'} />
      <Breadcrumb pageList={getPages(isAdmin, slug)} className="lg:mt-8" />

      {perk && (
        <>
          {/* Perk Details Bar */}
          <div className="xl:px-8 lg:px-6 px-4 py-[10px] sm:mt-6 mt-4 bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder border border-gray-200 rounded-lg flex sm:justify-between justify-center mb-0 items-center">
            <div className="font-medium text-sm flex items-center">
              <span>
                Perk {'  '} - {'  '}
                <span className="text-[1.2rem] font-bold">{perk.title}</span>
              </span>
            </div>
            {/* 
            <div className="flex flex-row sm:flex-nowrap items-center gap-2">
              <button
                onClick={handleManageUsers}
                className="btn-primary"
              >
                Manage Users
              </button>
            </div> */}
          </div>

          {/* Users Table Section */}
          <div className="mt-12">
            <div className="bg-white p-3 dark:bg-shoorah-darkBgTabColor border border-gray-300 dark:border-gray-600 rounded-lg overflow-hidden">
              <div className="flex justify-between items-center mb-6 gap-4">
                <div className="flex items-center gap-3">
                  <div className="flex-1 min-w-[250px]">
                    <SearchInput
                      id="searchKey"
                      name="searchKey"
                      type="text"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      placeholder="Search by name or email..."
                    />
                  </div>
                </div>
                <button
                  onClick={handleManageUsers}
                  className="btn-primary flex-shrink-0"
                >
                  Manage Users
                </button>
              </div>

              <TableCard
          pagination={{
            currentPage: currentPage,
            totalCount: totalCount,
            pageSize: selectedPerPage?.value,
            onPageChange: handlePagination,
            onPageSizeChange: (size) =>
              handlePerPage(PER_PAGE.find((o) => o.value === size) || PER_PAGE[0]),
            pageSizeOptions: PER_PAGE.map((o) => o.value)
          }}
        >
          <Table
                columns={columns}
                data={users}
                name={'offering_users'}
                bottomBorder={totalCount > selectedPerPage.value}
                loader={loader}
                refreshTable={refreshTable}
                contentType={1}
              />
        </TableCard>
            </div>

            {/* Pagination */}
            <div className="mt-4">
              
            </div>
          </div>
        </>
      )}

      {/* Add Users Modal */}
      <AddUsersModal
        isOpen={isAddUsersModalOpen}
        onClose={handleModalClose}
        onSuccess={handleModalSuccess}
        companyId={perk?.companyId?.id}
        isB2C={perk?.isB2C}
        offeringId={id}
        isAdmin={isAdmin}
        slug={slug}
      />
    </div>
  );
};

export default ManageOffering;
